/** Rail chrome shared by the Battery and Solar Setup rails, so both read alike. */
export const SETUP_MENU_WIDTH = `w-[max(300px,calc((100vw-min(100vw,var(--max-width-desktop)))/2))]`

export const STEP_LINK_BASE = `flex items-center gap-[18px] m-[5px] no-underline text-[0.9375rem] leading-[22px] font-display p-[7px]`
export const STEP_LINK_ACTIVE = `text-bp-accent font-semibold tracking-[-0.25px] [&_svg]:fill-bp-accent [&_path]:fill-bp-accent [&_g]:fill-bp-accent`
export const STEP_LINK_INACTIVE = `text-bp-text font-medium [&_svg]:fill-bp-text [&_path]:fill-bp-text [&_g]:fill-bp-text`

/** The indented list under the active group. */
export const GROUP_PARTS_LIST = `flex flex-col list-none border-l border-bp-border-strong pl-5 ml-[21px]`

/** A step link inside the active group's list. */
export const PART_LINK_BASE = `flex items-center gap-[18px] no-underline text-[0.875rem] leading-[21px] font-display p-[7px] rounded-[5px] mx-[5px]`
export const PART_LINK_ACTIVE = `bg-bp-elevated-2 font-semibold tracking-[-0.25px] text-bp-accent [&_svg]:fill-bp-accent [&_path]:fill-bp-accent [&_g]:fill-bp-accent`
export const PART_LINK_INACTIVE = `text-bp-text font-medium [&_svg]:fill-bp-text [&_path]:fill-bp-text [&_g]:fill-bp-text`
